import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import Navigation from "./navigations/Navigation";
import RoutesPath from "./utils/Routes";

// Screens
import HomeScreen from "./screens/App/Home/HomeScreen";
import ProfileScreen from "./screens/Auth/sign-up/ProfileScreen";
import SignUpScreen from "./screens/Auth/sign-up/SignUpScreen";
import LogInScreen from "./screens/Auth/log-in/LogInScreen";
import TrackScreen from "./screens/App/Track/TrackScreen";
import EarningScreen from "./screens/App/Earning/EarningScreen";
import VerifyPhoneNumberScreen from "./screens/App/VerifyPhoneNumberScreen";
import ReferralScreen from "./screens/App/Home/Referral/ReferralScreen";
import ReferralSubmisionScreen from "./screens/App/Home/Referral/ReferralSubmisionScreen";
import UpdateProfile from "./screens/Auth/sign-up/UpdateProfile";
import ProfileSendOTP from "./screens/Auth/sign-up/ProfileSendOTP";
import ProfileOTPSubmit from "./screens/Auth/sign-up/ProfileOTPSubmit";
import CreateNewPasswordScreen from "./screens/Auth/sign-up/CreateNewPasswordScreen";
import GetStarted from "./screens/Auth/GetStarted/Getstarted";
import PhoneNumberVerification from "./screens/Auth/sign-up/PhoneNumber.verification";
import DrawerNavigation from "./navigations/DrawerNavigation";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const auth = getAuth();

    // Listen for Firebase authentication state changes
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsAuthenticated(true);
        localStorage.setItem("Token", user.uid);

        // Force refresh user to get latest phone number
        await user.reload();
        const updatedUser = auth.currentUser; // Fetch latest user state

        // Check if phone number is linked after reload
        setIsPhoneVerified(!!auth.currentUser.phoneNumber);
      } else {
        setIsAuthenticated(false);
        setIsPhoneVerified(false);
        localStorage.removeItem("Token");
      }
      setAuthChecked(true);
    });

    // Cleanup function
    return () => {
      unsubscribe();
    };
  }, [isAuthenticated, isPhoneVerified]);

  const handlePhoneVerified = () => {
    setIsPhoneVerified(true);
  };

  if (!authChecked) {
    return <Navigation />; // Show Navigation (loading placeholder) until authentication check is done
  }

  return (
    <div
      style={{
        backgroundColor: "white",
        minHeight: "100vh",
        fontFamily: "League Spartan",
      }}
    >
      <Routes>
        {/* Public Routes */}
        <Route path={RoutesPath.LogIn} element={<LogInScreen />} />
        <Route path={RoutesPath.GetStarted} element={<GetStarted />} />
        <Route path={RoutesPath.SignUp} element={<SignUpScreen />} />
        <Route path={RoutesPath.ProfileSendOTP} element={<ProfileSendOTP />} />
        <Route
          path={RoutesPath.ProfileOTPSubmit}
          element={<ProfileOTPSubmit />}
        />
        <Route
          path={RoutesPath.PhoneNumberVerification}
          element={
            <PhoneNumberVerification
              handlePhoneVerified={handlePhoneVerified}
            />
          }
        />

        {/* Redirect to VerifyPhoneNumberScreen if phone is not verified */}
        {isAuthenticated && !isPhoneVerified ? (
          <>
            <Route
              path="*"
              element={
                <Navigate
                  to={RoutesPath.VerifyPhoneNumberScreen}
                  handlePhoneVerified={handlePhoneVerified}
                />
              }
            />
            <Route
              path={RoutesPath.VerifyPhoneNumberScreen}
              element={
                <VerifyPhoneNumberScreen
                  handlePhoneVerified={handlePhoneVerified}
                />
              }
            />
          </>
        ) : (
          isAuthenticated && (
            <>
              {/* Protected Routes (Require Authentication & Phone Verified) */}

              <Route path="/" element={<Navigate to={RoutesPath.Home} replace />} />
              <Route path="/index.html" element={<Navigate to={RoutesPath.Home} replace />} />
              <Route path={RoutesPath.Home} element={<HomeScreen />} />
              <Route path={RoutesPath.Track} element={<TrackScreen />} />
              <Route path={RoutesPath.Earning} element={<EarningScreen />} />
              <Route path={RoutesPath.Profile} element={<ProfileScreen />} />

              <Route path={RoutesPath.Referral} element={<ReferralScreen />} />
              <Route
                path={RoutesPath.ReferralSubmisionScreen}
                element={<ReferralSubmisionScreen />}
              />
              <Route
                path={RoutesPath.UpdateProfile}
                element={<UpdateProfile />}
              />
              <Route
                path={RoutesPath.CreateNewPasswordScreen}
                element={<CreateNewPasswordScreen />}
              />
              <Route
                path={RoutesPath.DrawerNavigation}
                element={<DrawerNavigation />}
              />
              {/* <Route
                path={RoutesPath.PhoneNumberVerification}
                element={<PhoneNumberVerification />}
              /> */}
              
            </>
            
          )
        )}

        {/* Redirect all unauthenticated users to login */}
        {!isAuthenticated && (
          <Route path="*" element={<Navigate to={RoutesPath.LogIn} />} />
        )}
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default App;
